import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { moduleOf, shellQuery } from '../api/shell'
import { Content } from '../ui/Shell'
import { ChangeProposalsPanel } from './ChangeProposalsPanel'

/**
 * `Changes::index` - pagina intreaga, la /app/change (adresa directa).
 *
 * Calea obisnuita e sertarul din dreapta (`ChangeDrawer`). Pagina include
 * ACELASI panou si aceleasi actiuni - deci merge la fel, doar in tot ecranul
 * in loc de sertar. `views/version-3/changes/index.php`.
 */
export function ChangeProposalsPage() {
  useQuery(shellQuery(moduleOf('/change')))
  const [deskOnly, setDeskOnly] = useState(false)

  return (
    <Content>
      <div className="row">
        <div className="col-md-12">
          <h3 style={{ margin: '4px 0 12px' }}>
            <i className="fas fa-robot" aria-hidden="true"></i> Change Proposals{' '}
            <small className="text-muted">What the AI proposes to run - and who approved it</small>
          </h3>
        </div>
      </div>
      <div className="btn-group btn-group-sm od-change-filter" role="group" aria-label="Which proposals" style={{ marginBottom: 12 }}>
        <button type="button" className={`btn ${deskOnly ? 'btn-default' : 'btn-primary'}`} aria-pressed={!deskOnly} onClick={() => setDeskOnly(false)}>
          All
        </button>
        <button type="button" className={`btn ${deskOnly ? 'btn-primary' : 'btn-default'}`} aria-pressed={deskOnly} onClick={() => setDeskOnly(true)}>
          From the desk
        </button>
      </div>
      <ChangeProposalsPanel deskOnly={deskOnly} />
    </Content>
  )
}
